export enum DeclinationEmailDialogFormNamesEnum {
  FORM_NAME = 'DeclinationEmailDialog',
  EMAIL = 'Email',
}
